import { createGlobalStyle, css } from "styled-components";

export default createGlobalStyle`
  ${({ theme, language }) => css`
    * {
      box-sizing: border-box;
      font-family: ${language && language === "en"
        ? theme.defaultFontFamily
        : theme.fontFamilyArabic};
      /* color: ${theme.colors.main.textMain}; */
      font-weight: ${theme.fontWeights.regular};
      letter-spacing: 0;
    }
    body {
      color: ${theme.colors.main.textMain};
    }
  `}
`;
